import { stringify } from '@angular/compiler/src/util';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../services/firebase.service';
import { UploadFileService } from '../services/upload-file.service';
@Component({
  selector: 'app-prof-theme-three',
  templateUrl: './prof-theme-three.component.html',
  styleUrls: ['./prof-theme-three.component.css']
})
export class ProfThemeThreeComponent implements OnInit {
  user!:string;
  approval_status!: string;
  end_date!:Date;
  today_dateget!:Date;


  // value show
  // basicdetails
  userfirstname!:string;
  usermiddlename!:string;
  userlastname!:string;
  profileurl!:string;
  companyname!:string;
  natureofbusiness!:string;
  posdesig!:string;
  phoneshow!:string;
  aphone!:string;
  landline!:string;
  whatsapp!:string;
  email!:string;
  website!:string;
  address!:string;
  // social media
  facebook!:string;
  instagram!:string;
  linkedin!:string;
  messenger!:string;
  telegram!:string;
  twitter!:string;
  youtube!:string;
// payment details
  gpayname !: string;
  gpay !: string;
  // paytm !: string;
  phonepename !: string;
  phonepe !: string;
  bankname !: string;
  accountholdername !: string;
  accountnumber !: string;
  ifsc !: string;
  savingscurrent !: string;


  // enquiry form
enemail !: string;
// Aboutus
abtus!: string;
obj : any;

// gallery urls
gallery_urls : any[] = [];

//products and services urls
pands_urls : any[] = [];

  constructor(private router: Router, private activatedRoute: ActivatedRoute, public firebaseService: FirebaseService,
    private firestore: AngularFirestore, private uploadService: UploadFileService ) {
      this.activatedRoute.queryParams.subscribe(params => {
        let users = params[':user'];
        this.user = users;})

        this.obj = JSON.parse(localStorage.getItem('user')|| '{}');
        this.router.routeReuseStrategy.shouldReuseRoute = function() {
          return false;
      };
         // basic details
      this.firestore.collection("basicdetails").ref.doc(this.user)
      .get()
      .then((querySnapshot) => {

        if(querySnapshot.exists){
              this.userfirstname = querySnapshot.data()['firstname'];
              this.usermiddlename = querySnapshot.data()['middlename'];
              this.userlastname = querySnapshot.data()['lastname'];
              this.profileurl = querySnapshot.data()['profileurl'];
              this.companyname = querySnapshot.data()['companyname'];
              this.natureofbusiness = querySnapshot.data()['natureofbusiness'];
              this.posdesig = querySnapshot.data()['posdesig'];
              this.phoneshow = querySnapshot.data()['phone'];
              this.aphone = querySnapshot.data()['aphone'];
              this.landline = querySnapshot.data()['landline'];
              this.whatsapp = querySnapshot.data()['whatsapp'];
              this.email = querySnapshot.data()['email'];
              this.website = querySnapshot.data()['website'];
              this.address = querySnapshot.data()['address'];
            }
      })
      .catch((error) => {
          console.log("Error getting documents: ", error);
      });
// social media details
this.firestore.collection("socialmedia").ref.doc(this.user)
.get()
.then((querySnapshot) => {
  if(querySnapshot.exists){
        this.facebook = querySnapshot.data()['facebook'];
        this.instagram = querySnapshot.data()['instagram'];
        this.linkedin = querySnapshot.data()['linkedin'];
        this.messenger = querySnapshot.data()['messenger'];
        this.telegram = querySnapshot.data()['telegram'];
        this.twitter = querySnapshot.data()['twitter'];
        this.youtube = querySnapshot.data()['youtube'];
      }
})
.catch((error) => {
    console.log("Error getting documents: ", error);
});


 // Payment Details
 this.firestore.collection("paymentdetails").ref.doc(this.user)
 .get()
 .then((querySnapshot) => {
   if(querySnapshot.exists){
        this.gpayname = querySnapshot.data()['gpayname'];
         this.gpay = querySnapshot.data()['gpay'];
        //  this.paytm = querySnapshot.data()['paytm'];
        this.phonepename = querySnapshot.data()['phonepename'];
         this.phonepe = querySnapshot.data()['phonepe'];
         this.bankname = querySnapshot.data()['bankname'];
         this.accountholdername = querySnapshot.data()['accountholdername'];
         this.accountnumber = querySnapshot.data()['accountnumber'];
         this.ifsc = querySnapshot.data()['ifsc'];
         this.savingscurrent = querySnapshot.data()['savingscurrent'];
        }
 })
 .catch((error) => {
     console.log("Error getting documents: ", error);
 });



 // enquiry Details
 this.firestore.collection("enquirydetails").ref.doc(this.user)
 .get()
 .then((querySnapshot) => {
   if(querySnapshot.exists){
        this.enemail = querySnapshot.data()['enqmail'];
        }
 })
 .catch((error) => {
     console.log("Error getting documents: ", error);
 });

 // aboutus Details
 this.firestore.collection("aboutus").ref.doc(this.user)
 .get()
 .then((querySnapshot) => {
   if(querySnapshot.exists){
        this.abtus = querySnapshot.data()['aboutus'];
        }
 })
 .catch((error) => {
     console.log("Error getting documents: ", error);
 });



// gallery Details gallery_urls
for(let i=1; i<=25; i++ ){
  this.firestore.collection("gallery").ref.doc(this.user).collection(i.toString()).doc(i.toString()).get().then((querySnapshot)=>{
      if(querySnapshot.exists){
        this.gallery_urls.push([querySnapshot.data()["galurl"]]);
    }else{

    }
  })
  .catch((error) => {
    console.log("Error getting documents: ", error);
  });

}


// products and service Details pands_urls
for(let i=1; i<=50; i++ ){
  this.firestore.collection("productsandservices").ref.doc(this.user).collection(i.toString()).doc(i.toString()).get().then((querySnapshot)=>{
      if(querySnapshot.exists){
        this.pands_urls.push([querySnapshot.data()["productname"],
        querySnapshot.data()["productprice"],querySnapshot.data()["pandsurl"]]);
    }else{

    }
  })
  .catch((error) => {
    console.log("Error getting documents: ", error);
  });


  }
}
  ngOnInit(): void {
  }
  enq_email(enqname:string,enqemail:string,enqsubject:string,enqmes:string){

    let email_formation !: any;
    email_formation = "mailto:"+this.enemail+"?subject="+enqsubject+
    "&body= Hi,%0D%0A I have contacted you for the below message,%0D%0A kindly contact me through this email id, "+
    enqemail+"%0D%0A  message: "+enqmes+"%0D%0A looking forward to hearing from you.%0D%0A Regards, %0D%0A"+enqname;
    window.location.href = email_formation;
  }

}
